<template>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <router-link to="/">
        <img
        v-lazy="'img/logo-wit.png'"
        alt="Thumbnail Image"
        class="navbar-img py-2"
      />
      </router-link>
    </template>
    <template slot="navbar-menu">
        <li class="nav-item">
        <router-link
          class="nav-link"
          to="/about"
        >
          About us
        </router-link>
      </li>
            <li class="nav-item">
        <router-link
          class="nav-link"
          to="/funds"
        >
          Funds
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/partners"
        >
          Partners
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/manager"
        >
          Manager
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/sustainability"
        >
          Sustainability
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/contact"
        >
          Contact
        </router-link>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  }
};
</script>

<style scoped>
.navbar-img {
  height: 40px;
  width: auto;
}
</style>
